import { render, staticRenderFns } from "./TheBanner.vue?vue&type=template&id=635518e2"
import script from "./TheBanner.vue?vue&type=script&lang=ts"
export * from "./TheBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports